module.exports = __webpack_public_path__ + "static/media/live-monitor-gray.5d6e8856.svg";